// extracted by mini-css-extract-plugin
export default {"description":"BasicTab__description___wl_w9","descriptionTabName":"BasicTab__descriptionTabName___DUwEA"};